import React from "react";

const RightArrow = ({ onClick }) => {
  return (
    <button
      className="absolute hidden md:flex top-[45%] translate-x-4 lg:translate-x-[15%] right-14 z-[4] w-[50px] h-[50px] border-0
  bg-white rounded-full text-black"
      title="Next Slide"
      onClick={onClick}
      style={{
        boxShadow: "0 6px 8px #0003",
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-7 w-7 m-auto"
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path
          fillRule="evenodd"
          d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z"
          clipRule="evenodd"
        />
      </svg>
    </button>
  );
};

export default RightArrow;
